export default __webpack_public_path__ + "static/media/purple_pawn.a9858b26.png";